import { SxProps, Theme } from '@mui/material';

export const breadcrumbTrailContainerSX: SxProps<Theme> = {
	'&:first-of-type': {
		mt: 4,
	},
};

export const customBreadcrumbTrailContainerSX = {
	container: (isCategoryPage?: boolean): SxProps<Theme> => ({
		width: '100%',
		mt: 2,
		...(isCategoryPage && { mb: 2 }),
		flexWrap: 'nowrap',
		overflowX: 'auto',
		'& .MuiBreadcrumbs-li:last-child': {
			overflow: 'inherit',
		},
		'& ol': {
			flexWrap: 'nowrap',
		},
	}),
};
